import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ROUTES } from './learner.routes';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';

//Components
import { Learner } from './components/main/learner.component';

//Services
import { CustomTranslationLoader } from '../app/services/custom-translation-loader';
import { LearnerProductViewResolverService } from './services/learner-product-view.resolver.service';
import { LearnerActivityViewResolverService } from './services/learner-activity-view-resolver.service';
import { CreateUserAnalytics } from './components/create-user-analytics/create-user-analytics.component';
import { CreateUserAnalyticsService } from './services/create-user-analytics.service';

@NgModule({
  declarations: [
    Learner,
    CreateUserAnalytics,
  ],
  imports: [
    CommonModule,
    ROUTES,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslationLoader
      }
    }),
    FormsModule,
    SharedModule
  ],
  providers: [
    LearnerProductViewResolverService,
    LearnerActivityViewResolverService,
    CreateUserAnalyticsService,
  ]
})
export class LearnerModule {
}
